import { InlineMessage } from '@strata/react-inline-message';

import { Columns } from 'components/shared/Columns';
import { Page } from 'components/shared/Page';
import { Section } from 'components/shared/Section';

const writeProducts = [
    <div key="1">
        <h4>When referencing products to customers or users always write out the product names:</h4>
        <ul>
            <li>FMH for Pharmacies</li>
            <li>FMH for Payers</li>
        </ul>
    </div>,
    <div key="2">
        <h4>Do Not use any of these alternatives</h4>
        <ul>
            <li>FMH + Pharmacies</li>
            <li>FMH Pharmacies</li>
            <li>FMHforPharmacies</li>
            <li>Pharmacies Application</li>
            <li>
                Pharmacies application or application for pharmacies can be used as a descriptor of
                FMH for Pharmacies. Same for FMH for Payers.
            </li>
        </ul>
    </div>,
];

const wordsAvoid = [
    <div key="1">
        <h4>When referencing products to customers or users always write out the product names:</h4>
        <ul>
            <li>FMH for Pharmacies</li>
            <li>FMH for Payers</li>
        </ul>
    </div>,
    <div key="2">
        <h4>Do Not use any of these alternatives</h4>
        <ul>
            <li>FMH + Pharmacies</li>
            <li>FMH Pharmacies</li>
            <li>FMHforPharmacies</li>
            <li>Pharmacies Application</li>
            <li>
                Pharmacies application or application for pharmacies can be used as a descriptor of
                FMH for Pharmacies. Same for FMH for Payers.
            </li>
        </ul>
    </div>,
    <p key="3">Avoid the words and phrases below and replace them with following suggestions.</p>,
    <Columns
        key="4"
        columns={Columns.ColumnNumber.TWOLOCK}
        content={
            <>
                <InlineMessage
                    wrapText
                    intent={InlineMessage.Intent.ERROR}
                    title="Avoid"
                    label="Auction or reverse auction"
                />
                <InlineMessage
                    wrapText
                    intent={InlineMessage.Intent.SUCCESS}
                    title="Instead Use"
                    label="Competitive bidding or dynamic price assignment"
                />
                <InlineMessage
                    wrapText
                    intent={InlineMessage.Intent.ERROR}
                    title="Avoid"
                    label="Winning bidder"
                />
                <InlineMessage
                    wrapText
                    intent={InlineMessage.Intent.SUCCESS}
                    title="Instead Use"
                    label="Best fit pharmacy"
                />
                <InlineMessage
                    wrapText
                    intent={InlineMessage.Intent.ERROR}
                    title="Avoid"
                    label="The marketplace (when referencing referrals out for bid)"
                />
                <InlineMessage
                    wrapText
                    intent={InlineMessage.Intent.SUCCESS}
                    title="Instead Use"
                    label="Live referrals"
                />
            </>
        }
    />,
];

export const Nomenclature = () => (
    <div>
        <Page
            pageTitle="Nomenclature"
            pageDescription="How to reference our products and a few words to avoid."
            pageContent={
                <>
                    <Section title="How to Write About Our Products" contentArray={writeProducts} />
                    <Section title="Words to Avoid" contentArray={wordsAvoid} />
                </>
            }
        />
    </div>
);
